import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useUser } from 'src/editor/shared/hooks/use-user'

export const useApplyUserLocale = () => {
  const { i18n } = useTranslation()
  const lastApplied = useRef<string | null>(null)
  const { data: user, isFetched: isUserFetched } = useUser()
  const userLocale = user?.dashboardLocale ?? null

  useEffect(() => {
    let isCancelled = false

    if (!userLocale) {
      return
    }

    ;(async () => {
      if (i18n.language === userLocale || lastApplied.current === userLocale) {
        if (!isCancelled) {
          lastApplied.current = userLocale
        }
        return
      }

      await i18n.changeLanguage(userLocale)
      if (isCancelled) {
        return
      }
      lastApplied.current = userLocale
    })()

    return () => {
      isCancelled = true
    }
  }, [i18n, userLocale])

  return { isUserFetched }
}
